// Pagination constants defined in CommonJS module format
// so they can be used easily in the backend
module.exports.PAGE_SIZE = 18;
